import React from 'react';
import './AboutContact.css';

function AboutContact() {
  return (
    <div className="about-contact container my-8">
      <h1 className="text-center text-primary">About Us & Contact</h1>
      <div className="content-section shadow-md rounded-lg p-6">
        <p>This Astrology & Numerology platform is developed by <strong>TweeLabs</strong>.</p>
        <p>TweeLabs is dedicated to creating insightful and user-friendly tools that help individuals explore the ancient wisdom of astrology and numerology.</p>
        <p>Visit our website: <a href="https://tweelabs.com" target="_blank" rel="noopener noreferrer">tweelabs.com</a></p>
        
        <h2>Contact Information</h2>
        <p>For support, inquiries, or feedback, please reach out to us:</p>
        <ul>
          <li>Email: <a href="mailto:info@tweelabs.com">info@tweelabs.com</a></li>
          <li>Address: [Your Company Address Here - Optional]</li>
          <li>Phone: [Your Phone Number Here - Optional]</li>
        </ul>
      </div>
    </div>
  );
}

export default AboutContact;
